import ApplicationController from "./application_controller";
import Sortable from "sortablejs";

export default class extends ApplicationController {
  static targets = ["picture"];

  connect() {
    this.sortable = Sortable.create(this.element, {
      sort: true,
      draggable: ".picture-container",
      animation: 150,
      onEnd: this.reOrderAll.bind(this),
    });
  }

  reOrderAll() {
    const items = document.querySelectorAll(".picture-container");
    [...items].forEach((item, index) => (item.querySelector(".picture-order").value = index));
  }
}
